import * as React from 'react'

import ReactSVG from 'react-svg'
import GameType from '../../data/games/gameTypes'

import ReplayIcon from '../../assets/img/replay.svg'

import { Button, Modal, Typography } from '@giantleap/components-library'
import classNames from 'classnames'
import styles from './style.module.scss'

interface INativeProps {
  open: boolean
  setOpen: (open: boolean) => void
  onClose?: () => void
  games: GameType[]
  isAccuracyFaultNotice: boolean
}

interface IProps extends INativeProps {}

export class AccuracyFaultModal extends React.PureComponent<IProps> {
  onClose = () => {
    const { onClose, setOpen } = this.props
    setOpen(false)
    if (onClose) {
      onClose()
    }
  }

  gotIt = () => this.onClose()

  render() {
    const { open, isAccuracyFaultNotice, setOpen } = this.props
    return (
      <Modal active={open} setActive={setOpen} baseClassName={styles.wrap}>
        <Typography type="title" size="big">
          Replay Games
        </Typography>
        <Typography type="text" textAlign="left">
          {isAccuracyFaultNotice
            ? `
            We noticed that your child might have been unfocused or attempted to
            complete games too quickly. Although it’s recommended to respond
            quickly, it’s even more important to concentrate on giving correct
            answers. When you think your child is ready, replay every game
            that's marked: `
            : `We noticed that your child might be struggling to complete a
            tutorial for one or more of the GiantLeap evaluation games. We
            recommend going over the tutorials together to ensure your child
            understands how to play each game before starting the evaluation.
            When you think your child is ready, replay every game that's marked: `}
          <ReactSVG
            src={ReplayIcon}
            className={classNames('text-img', styles.icon)}
          />
        </Typography>
        <Button color="black" onClick={this.gotIt} type="max">
          Got it
        </Button>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AccuracyFaultModal/index.tsx